import * as yup from "yup";

export const createRequiredNumberSchema = (requiredMessage: string, numberMessage: string) => {
  return yup
    .number()
    .transform((value, originalValue) => {
      if (originalValue === "" || originalValue === null || originalValue === undefined) {
        return undefined;
      }

      if (typeof originalValue === "number" && Number.isNaN(originalValue)) {
        return undefined;
      }

      return value;
    })
    .typeError(numberMessage)
    .required(requiredMessage);
};

export const createModeRequiredNumberSchema = (activeMode: string, requiredMessage: string) => {
  return yup
    .number()
    .defined()
    .nullable()
    .when("mode", {
      is: activeMode,
      then: (schema) => schema.required(requiredMessage),
      otherwise: (schema) => schema.nullable(),
    });
};
